import React from 'react';
import { isMemberDashboard as getIsMemberDashboard } from 'utils/is-member-dashboard';
import B2BApp from './AppB2B';
import B2CApp from './AppB2C';

function App()
{
    const isMemberDashboard = getIsMemberDashboard();

    return (
        <>
            {isMemberDashboard && (
                <B2BApp>
                </B2BApp>
            )}
            {!isMemberDashboard && (
                <B2CApp>
                </B2CApp>
            )}
        </>
    );
}
export default App;
